import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Compras } from './Compras';
import { Cotacoes } from './Cotacoes';
import { Fornecedores } from './Fornecedores';
import { Pedidos } from './Pedidos';
import { Recebimentos } from './Recebimentos';
import { Requisicoes } from './Requisicoes';
import { i18n } from './i18n';
import { i18nCompra } from './i18n-compra';
import { buscaCompras } from './busca-global';

/** Fase 2 (W8): requisição, cotação, pedido, recebimento e preços são o fluxo detalhado; a compra direta vale nos dois modos. */
const DETALHADO = { chave: 'compras.modo', em: ['detalhado'] };

const juntar = <B extends { abas: Record<string, string> }, E extends { abaCompras: string }>(base: B, extra: E) => ({ ...base, ...extra, abas: { compras: extra.abaCompras, ...base.abas } });

const modulo: ModuloWeb = {
  slug: 'compras',
  menu: 'operacao',
  ordem: 20,
  abas: [
    { chave: 'compras', permissao: 'compras.ver', componente: Compras },
    { chave: 'requisicoes', permissao: 'compras.ver', componente: Requisicoes, modo: DETALHADO },
    { chave: 'cotacoes', permissao: 'compras.ver', componente: Cotacoes, modo: DETALHADO },
    { chave: 'pedidos', permissao: 'compras.ver', componente: Pedidos, modo: DETALHADO },
    { chave: 'recebimentos', permissao: 'compras.ver', componente: Recebimentos, modo: DETALHADO },
    { chave: 'fornecedores', permissao: 'compras.ver', componente: Fornecedores, modo: DETALHADO },
  ],
  i18n: { pt: juntar(i18n.pt, i18nCompra.pt), en: juntar(i18n.en, i18nCompra.en), es: juntar(i18n.es, i18nCompra.es) },
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaCompras,
};

export default modulo;
